import { GenericAutocomplete } from "../../../../common/GenericAutocomplete";
import { useDeerFlowInstancesAutocomplete } from "../../hooks/use-deerflow-autocomplete";
import { useAppSelector } from "../../../../services/redux/hooks/use-selector";
import {
  selectDeerFlowInstances,
  selectDeerFlowMessageLoading,
  selectSelectedDeerFlowInstance,
} from "../../redux/selectors";
import { TDeerFlowInstance } from "../../redux/types";

export const DeerFlowInstancesAutocomplete = () => {
  const deerFlowInstances = useAppSelector(selectDeerFlowInstances);
  const selectedApp = useAppSelector(selectSelectedDeerFlowInstance);
  const { handleSelectInstance } = useDeerFlowInstancesAutocomplete();
  const isMessageLoading = useAppSelector(selectDeerFlowMessageLoading);
  return (
    <GenericAutocomplete<TDeerFlowInstance>
      options={deerFlowInstances}
      value={selectedApp}
      onChange={handleSelectInstance}
      getLabel={(app) => app.name}
      getValue={(app) => app.id}
      getOptionKey={(app) => app.id}
      autocompleteStyle={"select"}
      placeholder={"Выберите инстанс deerFlow"}
      isDisabled={isMessageLoading}
    />
  );
};
